export default {
  newQuoteLimitExceeded: "New quote quantity limit exceeded",
  plans: {
    planLimitExceeded: "Plan limit exceeded",
  },
  cardErrors: {
    cardDeclined: "Your card was declined.",
    zipCodeFailed: "The zip code you supplied failed validation.",
    cvcFailed: "Your card's security code is incorrect.",
    insufficientFunds: "Your card has insufficient funds.",
    cardExpired: "Your card has expired.",
    processingError:
      "An error occurred while processing your card. Try again in a little bit.",
    scaFailed: "SCA Validation failed",
  },
  unableToUpdateClientAndContacts:
    "You cannot update a client or its contacts for a Quote that has not been created yet.",
};
